/**
 * Function to format a product name.
 *
 * @param {String} name
 *
 * @return {String}
 */
export const productName = (name: string): string => {
  const decaRegex = /(decaffeinato)/i;
  const organicRegex = /(organic)/i;

  return name
    .replace(decaRegex, '<span class="decaffeinato">$1</span>')
    .replace(organicRegex, '<span class="organic">$1</span>');
};
